export const SetEnv = (prod, dev) => {
	if (process.env.NODE_ENV === 'production') {
		return prod
	} else return dev
}
